const RETRY_INTERVAL = 500

class ElementUpdater {
  constructor(selectors, updateFn) {
    this.selectors = selectors
    this.updateFn = updateFn
    this.retryCount = 0
  }

  get allElementsFound() {
    let allFound = true

    this.selectors.forEach((selector) => {
      if (selector.required) {
        const elements = document.querySelectorAll(selector.selection)

        if (elements.length === 0) {
          allFound = false
        }
      }
    })

    return allFound
  }

  attemptUpdate() {
    if (this.retryCount >= 50) {
      window.clearInterval(this.intervalId)
      return
    }

    if (this.allElementsFound) {
      window.clearInterval(this.intervalId)
      this.updateFn()
    } else {
      this.retryCount += 1
    }
  }

  update() {
    this.attemptUpdate()

    this.intervalId = window.setInterval(
      this.attemptUpdate.bind(this),
      RETRY_INTERVAL
    )
  }
}

export default ElementUpdater
